import { SetWinningsCommand } from "slotworks/commands/betbar/set-winnings-command";
import { JumpstartSpinCommand } from "slotworks/commands/comms/jumpstart-spin-command";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import Translations from "slotworks/i18n/translations";
import BetMenuFreespinsMediator from "slotworks/mediators/bet-menu-freespins-mediator";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import SmartButton from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";
import { parallel } from "slotworks/utils/race-utils";
import Layers from "../../../graphics/layers/layers";
import FlexiButton from "../../../graphics/elements/flexi-button";
import SettingsModel from "../../../model/settings/settings-model";
import Regulation from "slotworks/integration/revolver/regulations/regulation";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import HidePromoFSonFreespins from "slotworks/commands/promo-free-spins/hide-pfs-on-freespins";

export default class EnterRecoveryFreespins extends State {
    private homeButton: FlexiButton;
    private homeURL: string;
    public onEnter() {
        Regulation.interactionStart();
        const gameplay = GameState.getCurrentGame();
        const record = gameplay.getCurrentRecord() as FreespinRecord;

        // Increase remaining free spins and take away any won on this spin to simulate what count would be on previous result (which we don't have)
        const actualFreespins = record.remainingFreespins;
        record.remainingFreespins++;
        record.remainingFreespins -= record.freespinsWon;

        // if campaing is active we change the way smart button works to regular freespins
        HidePromoFSonFreespins();
        
        // Update smart button count
        SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);

        Components.betBar.setBetOptions(BetModel.generateBetOptions());
        Components.betBar.setType(BetBarType.FREESPINS);
        new BetMenuFreespinsMediator().start().execute();

        // Reset back to correct free spin count
        record.remainingFreespins = actualFreespins;

        Components.betBar.winnings.setWinnings(0, gameplay.getRunningFreespinsWinTotal() - gameplay.getCurrentRecord().creditsWon);
        this.homeButton = Layers.BetBar.getFlexiButton("home");
        this.homeURL = SettingsModel.homeURL;
        if (this.homeButton) {
            if (this.homeURL === "close" || this.homeURL === "" || this.homeURL === undefined || this.homeURL === null) {
                this.homeButton.setVisible(false);
            } else {
                this.homeButton.setVisible(true);
            }
        }
        Components.betBar.setEnabled(false);
        this.recoverFreespinsElements();

        const contents = new Map<string, string>();
        contents.set("body", Translations.get("rec.fre"));

        parallel([() => JumpstartSpinCommand(), () => Components.prompt.show(["info", "error"], contents)]).then(() => this.complete());
    }

    public complete() {
        GameState.getCurrentGame().inFreespinsGame = true;
        super.complete();
    }

    protected recoverFreespinsElements() {
        if (Layers.Background.hasScene("freespins")) {
            Layers.Background.jumpToScene("freespins");
        }
        if (Layers.MatrixBackground.hasScene("freespins")) {
            Layers.MatrixBackground.jumpToScene("freespins");
        }
        if (Layers.Header.hasScene("freespins")) {
            Layers.Header.jumpToScene("freespins");
        }

        Components.banner.setMode("freespins");
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/enter-recovery-freespins.ts